import {
  Row, Col, Spin, Breadcrumb, Table, Input, Pagination, Badge, Space, 
  Popconfirm, Empty,
} from "antd";
import Button from "antd/es/button";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { getAppHistoryList, getAndroidApp, updateAppStatus} from "../../axios/api.app";

import { useTranslation } from "react-i18next";

export const AppHistoryDetail = () => {
  const routeParams: any = useParams();
  const [appid, setAppId] = useState<string>(routeParams?.id);
  const [data, setData] = useState<any>();
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [appInfo, setAppInfo] = useState<any>({});

  const { t } = useTranslation();
  
  useEffect(() => {
    getList(pageIndex,pageSize);
    getAppDetail();
  }, []);

  function getAppDetail(){
    getAndroidApp(appid).then((res=>{
        setAppInfo(res)
      })
    )
  }
  function getList(pgIndx:number,pgSize:number){
    setPageIndex(pgIndx);
    setPageSize(pgSize);
    getAppHistoryList(appid,{
      pageIndex:pgIndx,
      pageSize:pgSize
    }).then((res) => {
      setData(res.dataList);
      setTotalCount(res.totalCount)
      setPageSize(res.pageSize);
      setPageIndex(res.pageIndex);
    });
    
  }

  const updateAppStatusClick = (appId:string,status:string) => {
    updateAppStatus(appId,status =="Active"?"Disabled":"Active")
      .then((res)=>{
        getList(pageIndex,pageSize);
      });
  };

  return (
    <>
      <div className="grayBox">
        <div className="breadcrumbTop py-2">
          <Breadcrumb>
            <Breadcrumb.Item>{t("应用管理")}</Breadcrumb.Item>
            <Breadcrumb.Item>{t("历史版本")}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <h3 className="px-4">{t("历史版本")}</h3>
        <Spin spinning={false}>
        <div className="mx-4">
          <Row className="grayBorderBox">
              <Space size={30} >
              <Col>
                <img src={appInfo?.logoUrl} width="80" ></img>
              </Col>
              <Col >
                <Row>
                    <Col className="ft-20">{appInfo?.name}</Col>
                </Row>
                <Row>
                   <Space size={10}>
                      <Col> {appInfo?.platform}</Col>
                      <Col>{t("版本")}： {appInfo?.versionNumber}</Col>
                      <Col>{t("大小")}： {appInfo?.appSize}</Col>
                    </Space> 
                </Row>
              </Col>
              </Space>
            </Row>
            <Row>
              <Col span={24}>
              <Table
                size="middle"
                className="minHeight"
                dataSource={data}
                pagination={false}
                onChange={(pagination) => {}}
                rowKey={record=>record.num}
                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
              >
                <Table.Column title={t("应用名称")} key="name" dataIndex="name"></Table.Column>
                <Table.Column title={t("版本号")} key="versionNumber" dataIndex="versionNumber"></Table.Column>
                <Table.Column title={t("包名")} key="packageName" dataIndex="packageName"></Table.Column>
                <Table.Column title={t("状态")} key="status" dataIndex="status"></Table.Column>
                <Table.Column title={t("更新时间")} key="updatedTime" dataIndex="updatedTime"></Table.Column>
                <Table.Column
                  title={t("操作")}
                  key="operation"
                  dataIndex="status"
                  render={(v,record: any, index: any) => {
                    return (
                      <>
                        <Popconfirm
                          title={ v == "Active" ? `${t("确认禁用吗")}？`:`${t("确认启用吗")}？`}
                          onConfirm={() => updateAppStatusClick(record?.appId,record?.status)}
                        >
                          <Button key={index} type="primary" ghost size="small">
                          { v == "Active" ? t("禁用"):t("启用") }
                          </Button>
                        </Popconfirm>
                      </>
                    );
                  }}
                ></Table.Column>
              </Table>
              <Pagination
                style={{ textAlign: "right", marginTop: "20px" }}
                pageSize={pageSize}
                current={pageIndex}
                total={totalCount}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} / ${total} ${t("条")}`
                }
                onChange={(page, pageSize) => {
                  getList(page, pageSize?pageSize:0);
                }}
                onShowSizeChange={(current, size) => getList(current, size)}
              ></Pagination>
              </Col>
            </Row>
        
          </div>
        </Spin>
      </div>
    </>
  );
};
